module.exports = __webpack_public_path__ + "static/img/jp.b3acc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/jp.png
// module id = WADX
// module chunks = 18